// extracted by mini-css-extract-plugin
export default {"volumeDisplay":"VolumeDisplay_volumeDisplay__3Sz9-"};